import { Issue, Article } from '../../../constants';
import { createContext } from 'react';

export const Context = createContext<ContextProps>({
	isAuthenticated: false,
	isMenuOpen: false,
	issues: [],
	isLoading: true,
	articles: [],
	onClickLogOut: () => {},
	setIsMenuOpen: () => {},
	toggleMenu: () => {},
});

interface ContextProps {
	isAuthenticated: boolean;
	isMenuOpen: boolean;
	issues: Array<Issue>;
	isLoading: boolean;
	articles: Array<Article>;
	onClickLogOut?: (url: string) => void;
	setIsMenuOpen: (value: boolean) => void;
	toggleMenu: Function;
}

export interface FeaturedArticle {
	article: Article;
	url: string;
}
